<template>
  <div class="main-body">
    <div class="main-panel"  style="height: 800px">
      <div class="main-title-wrap">
        <div class="main-title">催单管理</div>
      </div>
      <div class="main-content-wrap">
      <a-row>
        <a-col :span="24" class="table-style">
      <a-table
        :data-source="table.data"
        style="width: 100%">
        <a-table-column type="index" title="No." width="" align="center"
                         :index="table_index">
        </a-table-column>
        <a-table-column
          prop="order.orderNo"
          width="200" :show-overflow-tooltip='true'
          title="运输单号">
        </a-table-column>
        <a-table-column
          prop="order.ifsNo"
          title="IFS No.">
        </a-table-column>
        <a-table-column
          prop="order.wmsNo"
          title="WMS No.">
        </a-table-column>
        <a-table-column
          prop="order.gpsNo"
          title="GPS No.">
        </a-table-column>
        <a-table-column data-index="transportTypeStr" title="运输方式">
        </a-table-column>
        <a-table-column data-index="orderStatusStr" title="订单状态">
        </a-table-column>
        <a-table-column data-index="salesman.name" title="催件人">
        </a-table-column>
        <a-table-column data-index="salesman.telephone" title="催件人手机号">
        </a-table-column>

        <a-table-column
          prop="createAt"
          title="催件时间">
        </a-table-column>
        <a-table-column
          prop="date"
          title="操作">
          <template slot-scope="text, record">
            <a-button type="link" v-if="record.status === 0 && record.order.orderStatus !== 'CLOSED'" @click="changeExpediting(record.id)" v-has="'EXPECTING-DEAL'">去处理
            </a-button>
            <a-button type="link" v-else-if ="record.status === 1 && record.order.orderStatus !== 'CLOSED'"  v-has="'EXPECTING-DEAL'">处理中
            </a-button>
            <a-button type="link" v-else-if=" record.order.orderStatus === 'CLOSED'" v-has="'EXPECTING-DEAL'">已完成
            </a-button>
            <a-button type="link" @click="addToServiceTask(scope.$index)">转客服</a-button>
          </template>
        </a-table-column>
      </a-table>
          <div style="margin-top: 20px;text-align: center;">
            <a-pagination @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="table.query.page"
                           :page-sizes="[10,30,50]"
                           :page-size="table.query.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="table.query.total">
            </a-pagination>
          </div>
        </a-col>
      </a-row>
      </div>
    </div>
  </div>
</template>

<script>
import {
  _queryBizExpeditingList,
  _updateBizExpediting,
} from '@/api/bizExpeditingApi';
import {
    transportTypeFormat,
} from '../../../utils/formatConvert';
import {addServiceTask} from '../../../api/serviceTaskApi'

async function getBizExpeditingList() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascending' ? 'ASC' : 'DESC';
  }
  const result = await _queryBizExpeditingList({
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
  });
  const data = result.data.bizExpediting;
  if (data.length >0){
    this.table.data = data.map(x => ({
      ...x,
      orderStatusStr: x.order.orderStatus !== 'CLOSED' ? '在途' : '签收',
      statusStr: x.status !== 1 ? '未处理' : '已处理',
      transportTypeStr: transportTypeFormat(x.order.expressCode),
      deliveryAtStr: x.order.deliveryAt.substring(0, 10),
    }));
  }
  this.table.query.total = result.data.totalAmount;
}

async function changeExpediting(id) {
    const result = await _updateBizExpediting(id);
    if (result.code === 1200){
        this.$message({
            message: '处理成功',
            type: 'success',
        });
    }
    this.getBizExpeditingList();
}

/**
 * 显示条目数
 * @param val
 */
function handleSizeChange(val) {
    this.table.query.size = val;
    this.getBizExpeditingList();
}

/**
 * 当前页
 * @param val
 */
function handleCurrentChange(val) {
    this.table.query.page = val;
    this.getBizExpeditingList();
}

/**
 * 列表排列的序号
 * @param index
 * @returns {*}
 */
function table_index(index) {
    return (this.table.query.page - 1) * this.table.query.size + index + 1;
}

async function addToServiceTask(index) {
  const date = new Date();
  const time = date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date.getDate()+' '+date.getHours()+':'+date.getMinutes()+':'+date.getSeconds();
  const result = await addServiceTask({
    orderId: this.table.data[index].orderId
  });
  if (result.code === 1200){
    this.$message("成功提交")
  }
}

export default {
  name: 'BizExpeditingList',
  data() {
    return {
      form: {
        data: {
          id: null,
        },
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 10,
          total: 0,
        },
        sort: {
          prop: 'createAt',
          order: 'descend',
        },
      },
    };
  },
  methods: {
    addToServiceTask,
    getBizExpeditingList,
    changeExpediting,
    handleSizeChange,
    handleCurrentChange,
    table_index,
  },
  created() {
    this.getBizExpeditingList();
  },
};
</script>

<style scoped>

</style>
